'use client'

import React from 'react'
import { ContentfulImageSize, formatContentfulImageSrc } from '~/utils/assets/contentfulImage'
import styles from './FlightAviosOnlyBanner.module.scss'

const bannerSizes: ContentfulImageSize[] = [
  { width: 1920, height: 712, media: '(min-width: 1280px)', densities: [1, 2] },
  { width: 1280, height: 450, media: '(min-width: 1024px)', densities: [1, 2] },
  { width: 960, height: 400, media: '(min-width: 768px)', densities: [1, 2] },
  { width: 768, height: 320, media: '(min-width: 650px)', densities: [1, 2] },
  { width: 650, height: 228, media: '(min-width: 475px)', densities: [1, 2] },
  { width: 475, height: 228, media: '(max-width: 474px)', densities: [1, 2] },
]

type Props = {
  url: string
  sizes?: ContentfulImageSize[]
}

export function BannerBackgroundImage({ url, sizes = bannerSizes }: Props) {
  const backgroundStyles = Object.fromEntries(
    sizes.flatMap(({ width, height, media, densities: sizeDensities = [1] }) =>
      sizeDensities.map((dpi) => [
        dpi === 1 ? `@media ${media}` : `@media ${media} and (min-resolution: ${dpi}dppx)`,
        {
          backgroundImage: `url(${formatContentfulImageSrc(url, {
            width: width * dpi,
            height: height * dpi,
          })})`,
        },
      ])
    )
  )
  const classes = `${styles.bgImage} ${backgroundStyles}`
  return <div className={classes} style={{ backgroundImage: `url(${url})` }} />
}
